import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';
import DealerView from '../views/DealerView.vue';
import AuthRedirect from '../views/AuthRedirect.vue';
import InvoiceView from '../views/InvoiceView.vue';
import PayersView from '../views/PayersView.vue';
import BalanceRecordsViewVue from '@/views/BalanceRecordsView.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/auth/redirect',
        name: 'AuthRedirect',
        component: AuthRedirect,
    },
    {
        path: '/',
        name: 'home',
        component: HomeView,
    },
    {
        path: '/',
        name: 'dealer',
        component: DealerView,
    },
    {
        path: '/invoice/:accountId/:year/:month',
        name: 'invoice',
        component: InvoiceView,
    },
    {
        path: '/payers',
        name: 'payers',
        component: PayersView,
    },
    {
        path: '/balance-records/:accountId',
        name: 'balance-records',
        component: BalanceRecordsViewVue,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
